import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import config from '../../../../../../config.json';

async function getMasterServiceCategory(categoryId) {
  const { healtheraAppId } = config;

  const response = await axiosPrivate.get(`/v3/support/service-categories/${categoryId}`, {
    headers: {
      'app-id': healtheraAppId,
    },
  });
  return response.data;
}

export default function useGetMasterServiceCategory(categoryId) {
  return useQuery({
    queryKey: ['masterServiceCategory', categoryId],
    queryFn: () => getMasterServiceCategory(categoryId),
    enabled: !!categoryId && categoryId !== 'new-category',
  });
}
